import { useQuery } from '@tanstack/react-query';

import { queries } from '../api/queryKeys/queries';

export const useCustomerDetails = (customerId: string) => {
    return useQuery(queries.customers.detail(customerId));
};
